export default __webpack_public_path__ + "static/candidates-image-742fa36865518d7b041b723b9388ae4f.svg";